import { useEffect, type ReactNode } from 'react';
import { useUiStore } from '@app/store/ui.store';
import { applyTheme } from '@core/theme/theme';

interface ThemeProviderProps {
  children: ReactNode;
}

/**
 * Keeps the document theme in sync with UiStore and OS preference (system mode).
 */
export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useUiStore((state) => state.theme);

  useEffect(() => {
    applyTheme(theme);
  }, [theme]);

  useEffect(() => {
    if (theme !== 'system') return;

    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => applyTheme('system');

    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [theme]);

  return children;
}
